module.exports = __webpack_public_path__ + "images/category_lp/electric_tool/point3_59b14fc54bf57ee9cf85b7d31eabeb10.png";